(function(){
  window.dataLayer = window.dataLayer || [];
  window.PunskiTrack = function(eventName, params){
    var payload = Object.assign({event:eventName}, params || {});
    window.dataLayer.push(payload);
    if (typeof window.gtag === 'function') {
      // Reaches GA4 directly even when no GTM container is configured.
      // (If both GTM and GA4-via-gtag.js are active at once, make sure
      // GTM isn't also configured to send these same events, or you'll
      // double-count them in GA4.)
      window.gtag('event', eventName, params || {});
    }
    document.dispatchEvent(new CustomEvent('punski:'+eventName,{detail:payload}));
  };

  var header=document.querySelector('[data-header]');
  function onScroll(){if(!header)return;header.classList.toggle('is-scrolled',window.scrollY>24)}
  onScroll();window.addEventListener('scroll',onScroll,{passive:true});

  var navToggle=document.querySelector('[data-nav-toggle]');
  var siteNav=document.getElementById('SiteNav');
  if(navToggle&&siteNav){
    function setNavOpen(open){
      siteNav.setAttribute('data-open',open?'true':'false');
      navToggle.setAttribute('aria-expanded',open?'true':'false');
      navToggle.textContent=open?'Close':'Menu';
    }
    navToggle.addEventListener('click',function(){
      setNavOpen(siteNav.getAttribute('data-open')!=='true');
    });
    siteNav.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click',function(){setNavOpen(false)});
    });
  }

  document.addEventListener('click',function(e){
    var book=e.target.closest('[data-track-book-call]');
    if(book)window.PunskiTrack('book_call_click',{location:book.dataset.location||'site'});
    var packageLink=e.target.closest('[data-track-package]');
    if(packageLink)window.PunskiTrack('select_package',{package_name:packageLink.dataset.package||'',price:packageLink.dataset.price||''});
    var work=e.target.closest('[data-track-work]');
    if(work)window.PunskiTrack('portfolio_view',{work_title:work.dataset.work||''});
  });

  var contact=document.querySelector('#PunskiContact');
  if(contact){contact.addEventListener('submit',function(){window.PunskiTrack('contact_lead',{form_type:'project_inquiry'})});}

  var brief=document.querySelector('#ProjectBrief');
  if(brief){window.PunskiTrack('project_brief_start');brief.addEventListener('submit',function(){window.PunskiTrack('project_brief_complete')})}

  document.querySelectorAll('#PunskiProductForm').forEach(function(form){
    var submit=form.querySelector('[data-package-submit]');
    if(!submit)return;
    submit.addEventListener('click',async function(e){
      e.preventDefault();
      if(submit.disabled)return;
      submit.disabled=true;submit.dataset.originalText=submit.textContent;submit.textContent='Adding…';
      var mainVariant=form.querySelector('[name="id"]');
      var qty=form.querySelector('[name="quantity"]');
      var props={};
      form.querySelectorAll('[name^="properties["]').forEach(function(input){if(input.value)props[input.name.replace(/^properties\[/,'').replace(/\]$/,'')]=input.value});
      var items=[{id:Number(mainVariant.value),quantity:Number(qty?qty.value:1),properties:props}];
      form.querySelectorAll('[data-addon]:checked').forEach(function(cb){
        var quantity=1;
        var target=cb.closest('[data-addon-row]');
        var q=target && target.querySelector('[data-addon-qty]');
        if(q)quantity=Math.max(1,Number(q.value||1));
        items.push({id:Number(cb.value),quantity:quantity});
      });
      try{
        var res=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})});
        if(!res.ok)throw new Error('Could not add project to cart');
        window.PunskiTrack('add_to_cart',{product_id:mainVariant.value,addons:items.length-1});
        window.location.href='/cart';
      }catch(err){alert(err.message||'Something went wrong. Please try again.');submit.disabled=false;submit.textContent=submit.dataset.originalText}
    });
  });

  document.querySelectorAll('a[href="/checkout"],button[name="checkout"]').forEach(function(el){el.addEventListener('click',function(){window.PunskiTrack('start_checkout')})});
})();
